module.exports = __webpack_public_path__ + "static/media/logo-gold.32b01a9b.png";